<template>
  <div>
    <img style="width:100%;height:100%" src="../../../src/assets/img/acc.jpg"/>
  </div>
</template>
<script>

export default {
  name: 'netAcc',
 
  components:{},
  data(){
    return{
     
    }
  },
  methods:{
    
  },
  mounted(){
    
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 

</style>
